import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp, Container } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { TIMER } from "../../core/utills";
import { actions as giantWildActions } from "../../gamereducer/giantWildReducer";
import withSkullContainerConfiguration from "./configuration/withgiantwildconfiguration";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { actions as symbolActions } from "../../core/reducers/symbolStateReducer";
import { actions as reelgridAction } from '../../core/reducers/reelgridStateReducer';
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { BaseAnimatedparticle } from "../../core/components/effect/baseanimatedparticle";
import { PathTween } from "../../core/components/effect/pathtween";
import { configGame } from "../../data/config"
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { GlitchFilter } from '@pixi/filter-glitch';

interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class GiantWild extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected giantWild: any;
    protected ui_mode: string;
    protected displayUI: any;
    private storeParent: any
    private storeWild: any
    private storeIndex: any
    protected xAxis: number = configGame.REEL_CONTAINER_X;
    protected yAxis: number = configGame.REEL_CONTAINER_Y;
    private lastPivot: any;
    protected animX: number = 0;
    protected animY: number = 0;
    private lastPosition: any = [];
    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.giantWild = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    bindUI() {
        this.layoutChange(this.props.layoutMode);
        setTimeout(() => {
            //  this.changeCharacterSpineAnimationName();
        }, 3000);
    }


    initializeObjectInVariable() {

    }

    handleRotation(isFeatureShown: any) {

    }

    showHighlightedSkull(nextProps: any) {

    }

    componentDidMount() {
        this.initializeObjectInVariable();
        this.bindUI();
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {


        if (nextProps.startGiantWild !== this.props.startGiantWild
            || nextProps.giantWildPositions !== this.props.giantWildPositions
            || nextProps.inFreeGame !== this.props.inFreeGame
            || nextProps.blastStart !== this.props.blastStart
            || nextProps.giantWildRunning !== this.props.giantWildRunning
            || nextProps.spinStart !== this.props.spinStart
            || nextProps.updateDisplayWinDuration !== this.props.updateDisplayWinDuration
            || nextProps.bodyBuilderSelected !== this.props.bodyBuilderSelected
            || nextProps.reel_data !== this.props.reel_data
            || nextProps.layoutMode !== this.props.layoutMode
            || nextProps.soundIsPlaying !== this.props.soundIsPlaying
            || nextProps.allSoundSFXStop !== this.props.allSoundSFXStop
        ) {

            if (nextProps.layoutMode && nextProps.layoutMode !== this.props.layoutMode) {
                this.changeEffectAxisAccordingToScreen();

            }
            if (nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {
                this.resetSymbolLastConfig();
                this.clearSymbolData();

            }
            if (nextProps.startGiantWild && nextProps.startGiantWild !== this.props.startGiantWild) {

                this.changeCharacterSpineAnimationName(nextProps);
            }
            if (nextProps.spinStart && nextProps.spinStart !== this.props.spinStart) {
                this.clearSymbolData();

            }

            if (nextProps.updateDisplayWinDuration !== this.props.updateDisplayWinDuration) {
                this.props.configGame.DISPLAY_ALL_WIN_DURATION = nextProps.updateDisplayWinDuration;
            }
            return false;
        }
        return true;
    }

    resetSymbolLastConfig() {
        if (this.props.giantWildPositions.length) {
            let reel = this.props.giantWildPositions[1].reel
            let row = this.props.giantWildPositions[1].row
            let reelGrid = UIManager.getRef("gridGameCoulmn" + reel);
            if (reelGrid) {

                let symbolContainer: any = reelGrid.children[row];
                if (symbolContainer && this.lastPosition.length) {
                    symbolContainer.position.set(this.lastPosition[0], this.lastPosition[0]);
                    symbolContainer.pivot.set(this.lastPivot[0], this.lastPivot[0])
                    symbolContainer.scale.set(1);
                }

            }
        }


    }
    setAnimPosition() {

        if (isMobile && window.innerWidth > window.innerHeight) {
            this.animX = this.props.bodyBuilderSelected ? 1750 : 1350;
            this.animY = this.props.bodyBuilderSelected ? 825 : 470;
        }
        else if (isMobile && window.innerWidth < window.innerHeight) {
            this.animX = this.props.bodyBuilderSelected ? 992 : 708;
            this.animY = this.props.bodyBuilderSelected ? 1542 : 1270;
        }
        else {
            this.animX = this.props.bodyBuilderSelected ? 1815 : 1440;
            this.animY = this.props.bodyBuilderSelected ? 800 : 460;
        }

    }
    clearSymbolData() {
        this.props.setWinSymbolCoOrdinate([]);
        this.props.playSymbolAnim()
        let timer = TIMER.TimerManager.createTimer(800);
        timer.on('end', () => {
            let animContainer = UIManager.getRef("symbolanimationcontainer").children.length
            if (animContainer && this.lastPosition.length) {
                this.storeWild && this.storeWild.pivot.set(this.lastPivot[0], this.lastPivot[1])
                this.storeWild && this.storeWild.position.set(this.lastPosition[0], this.lastPosition[1])
                this.storeWild && this.storeWild.scale.set(1);
                this.storeParent && (this.storeParent.addChild(this.storeWild));
                this.storeWild = null;
                this.storeParent = null;
            }

        });
        timer.start();


    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        })
    }

    changeCharacterSpineAnimationName(nextProps: any) {

        let animName = this.getAnimationName()
        let characterAnim = this.props.bodyBuilderSelected ? UIManager.getRef(animName + this.ui_mode) : UIManager.getRef(animName + this.ui_mode)

        let spineName = "Action";
        if (characterAnim.spineAnimName === "Idle" && !nextProps.giantWildRunning) {
            characterAnim.children[0].state.onComplete = () => {
                if (!nextProps.giantWildRunning) {
                    if (this.props.giantWildPositions.length !== 9) {
                        nextProps.setGiantWildRunning(true);
                    }
                    characterAnim.spineAnimName = spineName;
                    characterAnim.children[0].state.setAnimation(0, spineName, false);
                    let timer = TIMER.TimerManager.createTimer(500);
                    timer.on('end', () => {

                        this.addPathTween()

                        if (characterAnim.spineAnimName === "Action") {
                            characterAnim.children[0].state.onComplete = () => {
                                characterAnim.children[0].state.setAnimation(0, "Idle", false);
                                characterAnim.spineAnimName = "Idle";

                            }
                        }
                    });
                    timer.start();

                }

            }
        }

    }

    getAnimationName(): string {

        let animName = this.props.bodyBuilderSelected ? "bodyBuilderCharacterIdle_" : "skeletonCharacterIdle_"
        if (this.props.inFreeGame) {
            animName = this.props.bodyBuilderSelected ? "fg_bodyBuilderCharecterIdle_" : "fg_skeletonCharacterIdle_"
        }
        return animName;
    }

    addScaleTween(obj: any) {
        if (obj) {
            let startScale = this.props.bodyBuilderSelected ? .6 : 1.2
            new Tween(
                [obj.scale],
                {
                    'x': { start: startScale, end: 1.4 },
                    'y': { start: startScale, end: 1.4 }
                },
                .5,
                easing.easeLinear,
                false, null, null, null, null, false, null, () => {

                }
            );
        }
    }
    addGlitch(obj: any) {
        let glitchProperties = {
            "seed": 0,
            "slices": 0,
            "offset": 300,
            "fillMode": 3,
            "average": false,
            "red": [-6, -6],
            "green": [-6, -6],
            "blue": [-6, -6],
            "minSize": 8,
            "sampleSize": 512
        }
        obj.filters = [new GlitchFilter(glitchProperties)];
        obj.filters[0].enabled = true;
        let timer = TIMER.TimerManager.createTimer(10);
        timer.on('repeat', (e: any) => {

            obj.filters[0] && (obj.filters[0].seed = Math.floor(50 * Math.random()) / 10)
        });
        timer.start(true);

        let timerEnd = TIMER.TimerManager.createTimer(300);
        timerEnd.on('end', (e: any) => {

            timer.remove();
            obj.filters[0] && (obj.filters[0].enabled = false)
        });
        timerEnd.start();
    }
    addWildBorder(x_pos: any, y_pos: any) {
        let animName = "wild_1X2_fx"
        let wildBorder = UIManager.getRef(animName)
        wildBorder.visible = true;
        // this.changeEffectAxisAccordingToScreen();

        let X_adjustment = 74;
        let Y_adjustment = this.props.bodyBuilderSelected ? 32 : 62
        let final_X = x_pos + X_adjustment;
        let final_Y = y_pos + 68 + Y_adjustment;
        let final_Scale = 1;
        if (isMobile && window.innerWidth < window.innerHeight) {
            final_X = (final_X - 23) * configGame.REEL_GRID_SCALE_IN_PORTRAIT;
            final_Y = (final_Y - 46) * configGame.REEL_GRID_SCALE_IN_PORTRAIT;
            final_Scale = configGame.REEL_GRID_SCALE_IN_PORTRAIT
        }
        wildBorder.position.set(final_X, final_Y)
        wildBorder.scale.set(final_Scale)
        setTimeout(() => {

            this.playYellowGlow(x_pos + 60, y_pos - 50, 1)
        }, 700);
    }

    addWildBorder3x3(x_pos: any, y_pos: any) {
        let animName = "wild_1X3_fx";
        let wildBorder = UIManager.getRef(animName)
        wildBorder.visible = true;
        // this.changeEffectAxisAccordingToScreen();
        let X_adjustment = 142;
        let Y_adjustment = this.props.bodyBuilderSelected ? 32 : 62

        let final_X = x_pos + X_adjustment;
        let final_Y = y_pos + 68 + Y_adjustment;
        let final_Scale = 1;
        if (isMobile && window.innerWidth < window.innerHeight) {
            final_X = (final_X - 23) * configGame.REEL_GRID_SCALE_IN_PORTRAIT;
            final_Y = (final_Y - 46) * configGame.REEL_GRID_SCALE_IN_PORTRAIT;
            final_Scale = configGame.REEL_GRID_SCALE_IN_PORTRAIT
        }
        wildBorder.position.set(final_X, final_Y)
        wildBorder.scale.set(final_Scale)

        //wildBorder.position.set(x_pos + X_adjustment, y_pos + 68 + Y_adjustment)
        setTimeout(() => {

            this.playYellowGlow(x_pos + 160, y_pos - 150, 2)
        }, 700);
    }


    addPathTween() {
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "giantwild1", loop: false }]);
        }
        this.changeEffectAxisAccordingToScreen();
        this.setAnimPosition();
        let animObj = this.props.bodyBuilderSelected ? UIManager.getRef("Orb_Fx_loop") : UIManager.getRef("skull_glow");
        //new PIXI.Container()
        if (animObj) {
            //let reel = 1
            //let row = 1

            animObj.position.set(this.animX, this.animY);
            let reel = this.props.giantWildPositions[1].reel;
            let row = this.props.giantWildPositions[1].row;
            if (this.props.giantWildPositions.length === 9) {
                reel = this.props.giantWildPositions[2].reel;
                row = this.props.giantWildPositions[2].row;
            }
            this.addScaleTween(animObj)
            animObj.visible = true;
            let Y_adjustment = this.props.bodyBuilderSelected ? 0 : 30
            let x_pos = this.xAxis + reel * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2
            let y_pos = this.yAxis + row * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2 - (Y_adjustment)
            let mid_x = x_pos + configGame.SYMBOL_WIDTH * 2
            let mid_y = y_pos - configGame.SYMBOL_WIDTH

            let newTween = new PathTween(
                animObj,
                [
                    { x: this.animX, y: this.animY },

                    { x: mid_x, y: mid_y },

                    { x: x_pos, y: y_pos },
                ],
                .5,
                "bezier",
                "easeLinear", null, false, false, (e: any) => {

                }, () => {
                    let gameScreen: any = UIManager.getRef("mainPageContainer");
                    this.addGlitch(gameScreen);
                    this.addWildBorder(x_pos, y_pos)
                    this.addFadeOutToOrb(animObj)
                    this.updateReelDataSymbols();
                }
            );
            newTween.start();
        }

    }

    addPathTween3x3() {
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: "giantwild2", loop: false }]);
        }
        this.changeEffectAxisAccordingToScreen();
        this.setAnimPosition();
        let animObj = this.props.bodyBuilderSelected ? UIManager.getRef("Orb_Fx_loop") : UIManager.getRef("skull_glow")
        //new PIXI.Container()
        if (animObj) {
            //let reel = 1
            //let row = 1
            let animName = this.getAnimationName()
            let characterAnim = this.props.bodyBuilderSelected ? UIManager.getRef(animName + this.ui_mode) : UIManager.getRef(animName + this.ui_mode)

            let spineName = "Action";
            characterAnim.children[0].state.setAnimation(0, spineName, false);
            let timer = TIMER.TimerManager.createTimer(500);
            timer.on('end', () => {
                if (characterAnim.spineAnimName === "Action") {
                    characterAnim.children[0].state.onComplete = () => {
                        characterAnim.children[0].state.setAnimation(0, "Idle", false);
                        characterAnim.spineAnimName = "Idle";

                    }
                }
            });
            timer.start();



            animObj.position.set(1815, 800)
            let reel = this.props.giantWildPositions[1].reel
            let row = this.props.giantWildPositions[1].row
            if (this.props.giantWildPositions.length === 9) {
                reel = this.props.giantWildPositions[2].reel;
                row = this.props.giantWildPositions[2].row;
            }
            this.addScaleTween(animObj)
            animObj.visible = true;
            let Y_adjustment = this.props.bodyBuilderSelected ? 0 : 30
            let x_pos = this.xAxis + reel * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2
            let y_pos = this.yAxis + row * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT / 2 - (Y_adjustment)
            let mid_x = x_pos + configGame.SYMBOL_WIDTH * 2
            let mid_y = y_pos - configGame.SYMBOL_WIDTH

            let newTween = new PathTween(
                animObj,
                [
                    { x: this.animX, y: this.animY },

                    { x: mid_x, y: mid_y },

                    { x: x_pos + 60, y: y_pos - 50 },
                ],
                .5,
                "bezier",
                "easeLinear", null, false, false, (e: any) => {

                }, () => {
                    let gameScreen: any = UIManager.getRef("mainPageContainer");
                    this.addGlitch(gameScreen);
                    this.addWildBorder3x3(x_pos, y_pos)
                    this.addFadeOutToOrb(animObj)
                    //this.updateReelDataSymbols();
                }
            );
            newTween.start();
        }

    }
    compare_prop_y(a: any, b: any) {
        // a should come before b in the sorted order
        if (a.y < b.y) {
            return -1;
            // a should come after b in the sorted order
        } else if (a.y > b.y) {
            return 1;
            // a and b are the same
        } else {
            return 0;
        }
    }
    updateReelDataSymbols() {
        let reel_data = this.props.reel_data;

        let positions = this.props.giantWildPositions
        let reel = this.props.giantWildPositions[1].reel
        let row = this.props.giantWildPositions[1].row
        let symIdToChange = 12;
        let zoomValue = 2;
        if (this.props.giantWildPositions.length === 9) {
            reel = this.props.giantWildPositions[2].reel;
            row = this.props.giantWildPositions[2].row;
            symIdToChange = 13;
            //zoomValue = 3;
        }

        let timer = TIMER.TimerManager.createTimer(500);
        timer.on('end', (e: any) => {
            e.remove();
            let reelGrid = UIManager.getRef("gridGameCoulmn" + reel);
            let reel_data = this.props.reel_data;


            reelGrid.children.sort(this.compare_prop_y);

            let symbolContainer: any = reelGrid.children[row];
            let xpos = symbolContainer.x;
            let ypos = symbolContainer.y;
            this.lastPosition = [xpos, ypos]

            this.lastPivot = [symbolContainer.pivot.x, symbolContainer.pivot.y]
            reel_data.stopReels[reel][row] = symIdToChange;
            this.props.onUpdateSymbolOnReel(symbolContainer, symIdToChange, false);

            symbolContainer.visible = true;
            symbolContainer.pivot.set(0, symbolContainer.height)
            symbolContainer.y = this.lastPosition[1] + configGame.SYMBOL_HEIGHT;

            symbolContainer.x = reel * configGame.SYMBOL_WIDTH
            this.storeIndex = this.lastPosition[1]
            this.storeParent = reelGrid;
            this.storeWild = symbolContainer;

            UIManager.getRef("symbolanimationcontainer").addChild(symbolContainer)
            new Tween(
                [symbolContainer],
                {
                    'alpha': { start: 0, end: 1 }
                },
                .3,
                easing.easeLinear,
                false, null, null, null, null, false, onchange, (e: any) => {
                    e.dispose();
                }
            );
            new Tween(
                [symbolContainer.scale],
                {
                    'x': { start: 1, end: zoomValue },
                    'y': { start: 1, end: zoomValue }
                },
                .3,
                easing.easeLinear,
                false, null, null, null, null, false, onchange, (e: any) => {
                    let animName = "wild_1X2_fx";
                    let wildBorder = UIManager.getRef(animName)
                    wildBorder.visible = false;

                    if (this.props.giantWildPositions.length === 9) {

                        let pathtimer = TIMER.TimerManager.createTimer(1400);
                        pathtimer.on('end', (e: any) => {
                            pathtimer.remove();
                            this.addPathTween3x3()

                            let wildtimer = TIMER.TimerManager.createTimer(900);
                            wildtimer.on('end', (e: any) => {
                                wildtimer.remove();
                                this.play3x3WildTween(symbolContainer);
                            });
                            wildtimer.start();
                        });
                        pathtimer.start();

                    }

                    //e.dispose();
                }
            );


        });
        timer.start();
    }

    playYellowGlow(x_pos: any, y_pos: any, scale: any) {
        let yellowGlow = UIManager.getRef("glow_yellow_blast")
        yellowGlow && (yellowGlow.visible = true);
        yellowGlow && yellowGlow.position.set(x_pos, y_pos);
        yellowGlow && yellowGlow.scale.set(scale);
        let spineName = "fx_glow_yellow";
        if (yellowGlow) {
            yellowGlow.children[0].state.setAnimation(0, spineName, false);
        }
    }

    play3x3WildTween(symbolContainer: any) {

        new Tween(
            [symbolContainer.scale],
            {
                'x': { start: 2, end: 3 },
                'y': { start: 2, end: 3 }
            },
            .3,
            easing.easeLinear,
            false, null, null, null, null, false, onchange, (e: any) => {
                let animName = "wild_1X3_fx";
                let wildBorder = UIManager.getRef(animName)
                wildBorder.visible = false;
                e.dispose();
            }
        );
    }

    changeEffectAxisAccordingToScreen() {
        let animName = (this.props.giantWildPositions.length === 9) ? "wild_1X3_fx" : "wild_1X2_fx"
        let wildBorder = UIManager.getRef(animName)
        if (isMobile && window.innerWidth < window.innerHeight) {
            this.xAxis = configGame.GIANT_WILD_EFFECT_PORTRAIT_X;
            this.yAxis = configGame.GIANT_WILD_EFFECT_PORTRAIT_Y;
            wildBorder.scale.set(configGame.REEL_GRID_SCALE_IN_PORTRAIT);
            wildBorder.x = configGame.GIANT_WILD_EFFECT_PORTRAIT_X;
            wildBorder.y = configGame.GIANT_WILD_EFFECT_PORTRAIT_Y;
        }
        else {
            this.xAxis = configGame.REEL_CONTAINER_X;
            this.yAxis = configGame.REEL_CONTAINER_Y;
            wildBorder.scale.set(1);
            wildBorder.x = configGame.REEL_CONTAINER_X;
            wildBorder.y = configGame.REEL_CONTAINER_Y;
        }
    }
    addFadeOutToOrb(animObj: any) {
        new Tween(
            [animObj],
            {
                'alpha': { start: 1, end: 0 },
            },
            .3,
            easing.easeLinear,
            false, null, null, null, null, false, onchange, () => {

                animObj.visible = false;
                animObj.alpha = 1;
            }
        );
    }

    addTilt(obj: any, angle: any) {
        new Tween(
            [obj],
            {
                'rotation': { start: obj.rotation, end: angle }
            },
            0.4,
            easing.easeLinear,
            false, null, null, null, null, false, null, () => {
                new Tween(
                    [obj],
                    {
                        'rotation': { start: obj.rotation, end: -angle }
                    },
                    0.5,
                    easing.easeLinear,
                    false, null, null, null, null, false, null, () => {
                        new Tween(
                            [obj],
                            {
                                'rotation': { start: obj.rotation, end: 0 }
                            },
                            0.1,
                            easing.easeLinear,
                            false, null, null, null, null, false, null, () => {

                            }
                        );
                    }
                );
            }
        );
    }

    render() {

        return (
            <UIManager id={"GiantWild"} name={"GiantWild"} type={"Container"}
                ref={i => this.giantWild = i} configGame={this.props.configGame}
                app={this.app} >
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                            scope={this} />
                    )
                }
            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'soundState' | 'freegameState' | 'RandomWildState' | 'gridsState' | 'skullState' | 'giantWildState'>): IStateToProps =>
    ({
        giantWildPositions: state.giantWildState.giantWildPositions,
        startGiantWild: state.giantWildState.startGiantWild,
        giantWildRunning: state.giantWildState.giantWildRunning,
        bodyBuilderSelected: state.giantWildState.bodyBuilderSelected,
        spinStart: state.gridsState.spinStart,
        blastStart: state.gridsState.blastStart,
        reel_data: state.gridsState.reel_data,
        updateDisplayWinDuration: state.RandomWildState.updateDisplayWinDuration,
        layoutMode: state.applicationState.layoutMode,
        inFreeGame: state.freegameState.inFreeGame,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        soundIsPlaying: state.soundState.soundIsPlaying,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setGiantWildRunning: (gianWildRunning: any): any => dispatch(giantWildActions.setGiantWildRunning(gianWildRunning)),
        playSymbolAnim: (): any => dispatch(winpresentationAction.playSymbolAnim()),
        setWinSymbolCoOrdinate: (winSymbolCoOrdinate: any): any => dispatch(winpresentationAction.setWinSymbolCoOrdinate(winSymbolCoOrdinate)),
        onUpdateSymbolOnReel: (symbol: any, symbolId: number, randomSymbol: boolean): any => dispatch(symbolActions.setUpdatedSymbol(symbol, symbolId, randomSymbol)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
    }))(withSkullContainerConfiguration(GiantWild)));